import script from "./HelpClickAnim.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpClickAnim.vue?vue&type=script&setup=true&lang=js"

import "./HelpClickAnim.vue?vue&type=style&index=0&id=a1d9039e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1d9039e"]])

export default __exports__